/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Progress_Lifts_SinceInputs */

const en_us2_progress_lifts_since = /** @type {(inputs: Progress_Lifts_SinceInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`over 1 week`);
	return /** @type {LocalizedString} */ (`over ${i?.weeks} weeks`)
	
};

const pt_br2_progress_lifts_since = /** @type {(inputs: Progress_Lifts_SinceInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`em 1 semana`);
	return /** @type {LocalizedString} */ (`em ${i?.weeks} semanas`)
	
};

const es_419_progress_lifts_since = /** @type {(inputs: Progress_Lifts_SinceInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`en 1 semana`);
	return /** @type {LocalizedString} */ (`en ${i?.weeks} semanas`)
	
};

const pt_pt2_progress_lifts_since = /** @type {(inputs: Progress_Lifts_SinceInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`em 1 semana`);
	return /** @type {LocalizedString} */ (`em ${i?.weeks} semanas`)
	
};

const fr_fr2_progress_lifts_since = /** @type {(inputs: Progress_Lifts_SinceInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`en 1 semaine`);
	return /** @type {LocalizedString} */ (`en ${i?.weeks} semaines`)
	
};

const de_de2_progress_lifts_since = /** @type {(inputs: Progress_Lifts_SinceInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`in 1 Woche`);
	return /** @type {LocalizedString} */ (`in ${i?.weeks} Wochen`)
	
};

const it_it2_progress_lifts_since = /** @type {(inputs: Progress_Lifts_SinceInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`in 1 settimana`);
	return /** @type {LocalizedString} */ (`in ${i?.weeks} settimane`)
	
};

/**
* | weeks | output |
* | --- | --- |
* | "1" | "over 1 week" |
* | * | "over {weeks} weeks" |
*
* @param {Progress_Lifts_SinceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_lifts_since = /** @type {((inputs: Progress_Lifts_SinceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Lifts_SinceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_lifts_since(inputs)
	if (locale === "es-419") return es_419_progress_lifts_since(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_lifts_since(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_lifts_since(inputs)
	if (locale === "de-DE") return de_de2_progress_lifts_since(inputs)
	if (locale === "it-IT") return it_it2_progress_lifts_since(inputs)
	return en_us2_progress_lifts_since(inputs)
});
export { progress_lifts_since as "progress.lifts_since" }